import { Box, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';

interface IViewToggler {}

const ViewToggler: React.FC<IViewToggler> = () => {
    const { toggleView, view, themeStyle } = useThemeContext();

    const handleViewChange = (event: SelectChangeEvent) => {
        toggleView(event.target.value);
        localStorage.setItem('view', event.target.value);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                '.MuiOutlinedInput-root': {
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                },
                '.MuiSvgIcon-root': {
                    color: theme[themeStyle].tag_white,
                },
                '.MuiOutlinedInput-notchedOutline': { border: 0 },
                '.MuiSelect-select': { p: 0 },
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    border: 0,
                },
            }}>
            <Select
                name="viewToggler"
                sx={{
                    color: theme[themeStyle].tag_white,
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            backgroundColor: theme[themeStyle].tertiary_white,
                            color: theme[themeStyle].tag_white,
                            '& .MuiButtonBase-root:hover': {
                                backgroundColor: theme[themeStyle].role_hover,
                            },
                            '& .Mui-selected': {
                                backgroundColor: theme[themeStyle].selected_grey_orange,
                            },
                        },
                    },
                }}
                value={view}
                onChange={handleViewChange}>
                <MenuItem sx={{ fontFamily: FONT_ENUM.MAIN_MEDIUM }} value="grid">
                    Grid
                </MenuItem>
                <MenuItem sx={{ fontFamily: FONT_ENUM.MAIN_MEDIUM }} value="table">
                    Table
                </MenuItem>
            </Select>
        </Box>
    );
};

export { ViewToggler };
